import { create } from "zustand";
import { devtools, subscribeWithSelector } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

export interface UserState {
	// Active group/role session state (which group the user is acting as)
	selectedGroupId: string | undefined;
	relationship: "buyer" | "seller" | undefined;

	// Actions
	setSelectedGroup: (params: { selectedGroupId?: string; relationship?: "buyer" | "seller" }) => void;
	clearSelectedGroup: () => void;
}

export const useUserStore = create<UserState>()(
	devtools(
		subscribeWithSelector(
			immer(set => ({
				selectedGroupId: undefined,
				relationship: undefined,

				setSelectedGroup: ({ selectedGroupId, relationship }) =>
					set(state => {
						if (selectedGroupId) state.selectedGroupId = selectedGroupId;
						if (relationship) state.relationship = relationship;
					}),

				clearSelectedGroup: () =>
					set(state => {
						state.selectedGroupId = undefined;
						state.relationship = undefined;
					}),
			})),
		),
		{ name: "user-store" },
	),
);
